import { render } from "./MatchFeedbackCard.vue?vue&type=template&id=c3df68c4"
import script from "./MatchFeedbackCard.vue?vue&type=script&lang=js"
export * from "./MatchFeedbackCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__